import { AudioFileModel } from '@/types/TextToSpeech';
import { buildAPIUrl, responseInterceptor } from '.';

export const audioFileExistOnCloud = async (reportId: number): Promise<boolean> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/TextToSpeech/AudioFileExistOnCloud`, {
      method: 'POST',
      body: JSON.stringify({ reportId }),
    }),
  );
  return response.json();
};

export const getAudioFileFromCloud = async (reportId: number): Promise<AudioFileModel> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/TextToSpeech/GetAudioFileFromCloud`, {
      method: 'POST',
      body: JSON.stringify({ reportId }),
    }),
  );
  return response.json();
};
